import {
  multi,
  number,
  OTHER,
  option,
  single,
  text,
  type UsWorksheetDefinition,
} from "../us-fields";

export const US_OCULAR: UsWorksheetDefinition = {
  examType: "us_ocular",
  version: 1,
  indications: [
    option("ocular_trauma", "Ocular trauma"),
    option("visual_disturbance", "Visual disturbance"),
    option("flashes_or_floaters", "Flashes or floaters"),
    option("raised_icp", "Suspected raised intracranial pressure"),
  ],
  sections: [
    {
      id: "ocular_eye_evaluated",
      label: "Eye evaluated",
      role: "findings",
      fields: [
        multi("ocular.eye_evaluated", "Eye evaluated", [
          option("left", "Left"),
          option("right", "Right"),
          option("both", "Both"),
        ]),
      ],
    },
    {
      id: "ocular_eye",
      label: "",
      role: "findings",
      technicallyLimited: true,
      repeatPerSide: ["right_eye", "left_eye"],
      showSideWhen: {
        field: "ocular.eye_evaluated",
        in: { right_eye: ["right", "both"], left_eye: ["left", "both"] },
      },
      fields: [
        single(
          "ocular.lens",
          "Lens",
          [
            option("normal_position", "Normal position"),
            option("dislocated", "Dislocated"),
            option("indeterminate", "Indeterminate"),
          ],
          { normal: "normal_position" },
        ),
        multi("ocular.posterior_chamber", "Posterior chamber", [
          option("normal", "Normal"),
          option("retinal_detachment", "Retinal detachment"),
          option(
            "posterior_vitreous_detachment",
            "Posterior vitreous detachment",
          ),
          option("debris", "Debris"),
          option("foreign_body", "Foreign body"),
          option("indeterminate", "Indeterminate"),
        ]),
        number(
          "ocular.optic_nerve_sheath_diameter",
          "Optic nerve sheath diameter",
          "mm",
        ),
        text("ocular.other_findings", "Other"),
      ],
    },
    {
      id: "ocular_impression",
      label: "Impression",
      role: "impression",
      fields: [
        multi("ocular.impression", "Impression", [
          option("normal_ocular", "Normal focused ocular ultrasound"),
          option("lens_dislocation", "Lens dislocation"),
          option("retinal_detachment", "Retinal detachment"),
          option(
            "posterior_vitreous_detachment",
            "Posterior vitreous detachment",
          ),
          option("open_globe", "Suspected open globe/globe rupture"),
          option("foreign_body", "Foreign body"),
          option("elevated_icp", "Elevated intracranial pressure"),
          option("indeterminate", "Indeterminate"),
          OTHER,
        ]),
      ],
    },
  ],
  normalImpressions: [
    { sectionId: "ocular_impression", value: "normal_ocular" },
  ],
  billing: {
    codes: [
      { cpt: "76512", label: "Ocular Ultrasound", preTick: true },
      { cpt: "76529", label: "Ultrasound localization of Ocular Foreign Body" },
    ],
  },
};
